// @flow
import { connect } from 'react-redux';
import { assign } from 'lodash';
import { stringify } from 'query-string';
import HeaderMenu from '../components/molecules/HeaderMenu';

import {
    getAndStoreDashboards,
    getAndStoreReports,
    getAndStoreGrids,
    getAndStoreUsers
} from '../modules/actions';

function mapStateToProps(state: State) {
    return {
        dashboards: state.dashboards,
        user: state.user,
        reports: state.reports,
        grids: state.grids
    };
}

function mapDispatchToProps(dispatch, ownProps) {
    return {
        onChangeClient: (clientId: Guid) => {
            ownProps.history.replace(
                assign({}, ownProps.location, {
                    pathname: `/`,
                    search: stringify({ clientId: clientId })
                })
            );
            dispatch(getAndStoreUsers(clientId));
        },
        onGetDashboards: clientId => dispatch(getAndStoreDashboards(clientId)),
        onGetReports: clientId => dispatch(getAndStoreReports(clientId)),
        onGetGrids: clientId => dispatch(getAndStoreGrids(clientId)),
        onNavigate: (pathname: string) => {
            ownProps.history.push(assign(ownProps.location, { pathname: pathname }));
        }
    };
}

export default connect(mapStateToProps, mapDispatchToProps)(HeaderMenu);



// WEBPACK FOOTER //
// ./containers/HeaderMenuContainer.jsx